var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{key:_vm.key},[_c('Header'),(this.$route.path != '/404')?_c('v-divider',{staticClass:"d-md-none"}):_vm._e(),_c('router-view'),_c('v-spacer'),(this.$route.path != '/404')?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }